<template>
  <div>
    <br>
    <v-flex xs12>
      <v-card>
        <v-col>
          <busca-ano-nivel-etapa @chosen="chosen" :setSteps="2"></busca-ano-nivel-etapa>
          <v-alert type="error" :value="($v.$invalid && $v.$dirty) || msgArrayError.length > 0" style="color: white;">
            <div v-if="$v.$invalid && $v.$dirty"> Preencha os campos corretamente.</div>
            <div v-if="msgArrayError.length > 0">
              <ul v-for="error of msgArrayError" :key="error.key">
                <li>{{ error }}</li>
              </ul>
            </div>
          </v-alert>
          <form @submit.prevent="onSubmit">
            <v-container v-show="tabMinimo">
              <table class="table-siged">
                <thead>
                  <tr>
                    <th></th>
                    <th>Valor</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Minímo para Promoção</td>
                    <td>
                      <InputTable type="number"
                      @input="inputChange"
                      @keydown="stopArrowsAction"
                      v-model="formMinimo.valorminimopromocao"
                      :msgsError="msgValidacaoMin($v.formMinimo.valorminimopromocao)"/>

                      <span class="config-input-span">%</span>
                    </td>
                  </tr>
                  <tr>
                    <td>Minímo para Frequência</td>
                    <td>
                      <InputTable type="number"
                      @input="inputChange"
                      @keydown="stopArrowsAction"
                      v-model="formMinimo.valorminimofrequencia"
                      :msgsError="msgValidacaoMin($v.formMinimo.valorminimofrequencia)"/>
                      <span class="config-input-span">%</span>
                    </td>
                  </tr>
                  <tr>
                    <td>Dias de tolerância de alunos transferidos, desistentes e evadidos para lançamento de notas/conceito</td>
                    <td>
                      <InputTable type="number"
                      @input="inputChange"
                      @keydown="stopArrowsAction"
                      v-model="formMinimo.quantidadediastoleranciatransf"
                      :msgsError="msgValidacaoMin($v.formMinimo.quantidadediastoleranciatransf)"/>
                      <span class="config-input-span">dias</span>
                    </td>
                  </tr>
                  <tr>
                      <td>Este ano letivo ultrapassará o ano corrente?</td>
                      <td>
                      <CheckBoxCustom
                        trueValue="S"
                        falseValue="N"
                        v-model="formMinimo.indicaanoletivoexcedeu"
                        @input="inputChange"
                        :val="(formMinimo.indicaanoletivoexcedeu)? 'S' :  'N'"
                      />
                      </td>
                  </tr>
                  <tr v-if="formMinimo.indicaanoletivoexcedeu === 'S'">
                    <td>Justificativa para ano letivo excedido</td>
                    <td style="">
                        <TextArea @input="inputChange"
                        style="width: 600px;"
                        rows="5"
                          v-model="formMinimo.descricaojustificativaanoletivoexcedido"
                          :v="$v.formMinimo.descricaojustificativaanoletivoexcedido"
                          :disabled="false"/>
                      </td>
                  </tr>
                  <tr>
                      <td>Modelo de aula</td>
                      <td style="max-width: 600px; word-wrap:break-word;">
                      <Validator label="" :v="$v.formMinimo.indicamodelodeaula">
                        <Radio @input="inputChange" v-model="formMinimo.indicamodelodeaula" :disabled="acao == ''" val="P" @blur="$v.formMinimo.indicamodelodeaula.$touch()" label="Presencial (professores e alunos presenciais)"/><br>
                        <Radio @input="inputChange" v-model="formMinimo.indicamodelodeaula" :disabled="acao == ''" val="R" @blur="$v.formMinimo.indicamodelodeaula.$touch()" label="Remoto (professores e alunos remotos)"/>
                        <Radio @input="inputChange" v-model="formMinimo.indicamodelodeaula" :disabled="acao == ''" val="H" @blur="$v.formMinimo.indicamodelodeaula.$touch()" label="Híbrido (professores e alunos presenciais e remotos)"/>
                        <Radio v-if="false" @input="inputChange" v-model="formMinimo.indicamodelodeaula" :disabled="acao == ''" val="M" @blur="$v.formMinimo.indicamodelodeaula.$touch()" label="Misto (professores presentes, alunos híbridos)"/>
                      </Validator>
                      </td>
                  </tr>
                  <tr>
                      <td>Neste ano letivo o aluno PDI receberá lançamentos (Notas/Conceitos)?</td>
                      <td>
                      <CheckBoxCustom
                        trueValue="S"
                        falseValue="N"
                        v-model="formMinimo.pdirecebelancamento"
                        @input="inputChange"
                        :val="(formMinimo.pdirecebelancamento)? 'S' :  'N'"
                      />
                      </td>
                  </tr>
                  <tr>
                      <!-- <td>Existe número de aulas exigido para este nível de ensino?</td> -->
                      <td>Para este nível de ensino existe número mínimo de aulas obrigatório?</td>
                      <td>
                      <CheckBoxCustom
                        trueValue="S"
                        falseValue="N"
                        v-model="formMinimo.indicaexigenumerodeaulas"
                        @input="inputChange"
                        :val="(formMinimo.indicaexigenumerodeaulas)? 'S' :  'N'"
                      />
                      </td>
                  </tr>

                </tbody>
              </table>

            </v-container>

            <v-container v-show="tabFechamento">
              <table class="table-siged">
                <thead>
                  <tr>
                    <th></th>
                    <th colspan="3">Período Avaliativo</th>
                  </tr>
                  <tr>
                    <th></th>
                    <th v-for="(data, index) in tabelaFechamento" :key="index">{{data.dspravadi}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Data de Abertura do diário</td>
                    <td v-for="(data, index) in tabelaFechamento" :key="index">
                      <InputDateTable v-model="data.datainicio" @input="inputChange"
                      :msgsError="msgValidacaoAbe($v.formFechamento.$each[index].datainicio)"/>
                    </td>
                  </tr>
                  <tr>
                    <td>Data de Fechamento do diário</td>
                    <td v-for="(data, index) in tabelaFechamento" :key="index">
                      <InputDateTable v-model="data.datafim" @input="inputChange"
                      :msgsError="msgValidacaoFec($v.formFechamento.$each[index].datafim)"/>
                    </td>
                  </tr>
                </tbody>
              </table>
            </v-container>
            <div id="btn-acoes-b" v-if="(tabMinimo && tabFechamento)" >
              <v-btn type="submit" :loading="loading && !loading2" small :disabled="loading || !habilitarBotoes" color="teal" class="teste me-2 rounded-sm font-weight-regular">Salvar</v-btn>
              <v-btn type="button" small color="" :loading="loading2" :disabled="loading2 || loading || !habilitarBotoes" @click="cancelar">Cancelar</v-btn>
            </div>
          </form>
        </v-col>
      </v-card>
    </v-flex>
    <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0"  >
        <div class="d-flex justify-space-between align-center">
           <span> {{ submitText }}</span>
            <v-btn class="text-right" variant="text"  icon  @click="snackbar = false" > <v-icon>close</v-icon> </v-btn>
        </div>
    </v-snackbar>
  </div>
</template>

<script>
import moment from 'moment';
import BuscaAnoNivelEtapa from '@/components/BuscaAnoNivelEtapa';
import InputTable from '@/components/InputTable';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import {
  required, maxLength, integer, minValue, maxValue, requiredIf,
} from 'vuelidate/lib/validators';
import _ from 'lodash';

const CAARepository = RepositoryFactory.get('configuracaoAnoLetivo');

const setFormMinimo = () => ({
  identificadorconfiguracaoanoletivo: '',
  aaletivo: '',
  valorminimopromocao: '',
  valorminimofrequencia: '',
  cdinstruc: '',
  indicaativo: 'S',
  datahoracadastro: '',
  quantidadediastoleranciatransf: 30,
  indicaanoletivoexcedeu:'N',
  descricaojustificativaanoletivoexcedido: '',
  indicamodelodeaula: '',
  pdirecebelancamento: 'N',
  indicaexigenumerodeaulas: 'S',
});

const setFormFechamento = () => ({
  identificadorcontrolediario: '',
  aaletivo: '',
  cdinstruc: '',
  cdpravadi: '',
  datainicio: '',
  datafim: '',
});

export default {
  name: 'ConfiguracaoAnoAvaliativo',
  components: {
    BuscaAnoNivelEtapa,
    InputTable,
  },
  data(){
    return{
      acaoMinimo: 'novo',
      anoletivo: '',
      nivelescolar:'',
      formMinimo: setFormMinimo(),
      formFechamento: Object,
      loading: false,
      loading2: false,
      tabMinimo: false,
      tabFechamento: false,
      submitText: '',
      snackbar: false,
      msgArrayError: [],
      habilitarBotoes: false,
      tipoDeEnsino: '',
    }
  },
   validations() {
    return {
      formFechamento:{
        required,
        $each:{
          datainicio: {
            required,
            isValidDate: function(campo, valor) {
              return  moment(valor.datainicio, 'DD/MM/YYYY').isValid()
            },
            minValue: function(campo, valor){
              return (moment(valor.datainicio, 'DD/MM/YYYY').format('YYYY-MM-DD') >= `${this.anoletivo}-01-01`);
            },
            maxValue: function(campo, valor){
                if (this.formMinimo.indicaanoletivoexcedeu === 'N') {
                  return (moment(valor.datainicio, 'DD/MM/YYYY').format('YYYY-MM-DD') <= `${this.anoletivo}-12-31`);
                }
                else {
                  return (moment(valor.datainicio, 'DD/MM/YYYY').format('YYYY-MM-DD') <= valor.datafim);
                }
            }
          },
          datafim: {
            required,
            isValidDate: function(campo, valor) {
              return  moment(valor.datafim, 'DD/MM/YYYY').isValid()
            },
            minValue: function(campo,valor){
              return ( moment(valor.datafim, 'DD/MM/YYYY').format('YYYY-MM-DD') >= moment(valor.datainicio, 'DD/MM/YYYY').format('YYYY-MM-DD') );
            },
            maxValue: function(campo, valor){
              if (this.formMinimo.indicaanoletivoexcedeu === 'N') {
                  return ( moment(valor.datafim, 'DD/MM/YYYY').format('YYYY-MM-DD') <= `${this.anoletivo}-12-31`);
                }
                else {
                  return ( moment(valor.datafim, 'DD/MM/YYYY').format('YYYY-MM-DD') >= moment(valor.datainicio, 'DD/MM/YYYY').format('YYYY-MM-DD') );
                }
            }
          },
        },
      },
      formMinimo:{
        valorminimopromocao:{
          required: requiredIf(() => this.tipoDeEnsino !== '0'),
          integer, minValue: minValue(0), maxValue: maxValue(100)
        },
        valorminimofrequencia:{
          required: requiredIf(() => this.tipoDeEnsino !== '0'),
          integer, minValue: minValue(0), maxValue: maxValue(100)
        },
        //  quantidadediastoleranciatransf: { required, integer, minValue: minValue(0), maxValue: maxValue(120) },
        quantidadediastoleranciatransf: { required, integer, minValue: minValue(0), maxValue: maxValue(366) },

        descricaojustificativaanoletivoexcedido: { required: requiredIf( function(formMinimo){
                    return formMinimo.indicaanoletivoexcedeu === 'S'
                }),
                maxLength: maxLength(600)
        },
        indicamodelodeaula:{
          required
        },

      }
     };
  },
  created() {
    this.$Progress.finish();

  },
  methods: {
    inputChange() {
      this.habilitarBotoes = true;
      this.changeAnoLetivoExcedido();

    },
    changeAnoLetivoExcedido() {
      if (this.formMinimo.indicaanoletivoexcedeu === 'N') {
        this.formMinimo.descricaojustificativaanoletivoexcedido = ''

      }
    },
    msgValidacaoMin(v){
      if(!v.required)
        return ['Campo obrigatório'];
      if(!v.minValue)
        return[`O valor minímo deve ser ${v.$params.minValue.min}`];
      if(!v.maxValue)
        return [`O valor máximo deve ser ${v.$params.maxValue.max}`];
    },
    msgValidacaoFec(v){
      if(!v.required)
        return ['Campo obrigatório'];
      if(!v.isValidDate)
        return[`Data inválida`];
      if(!v.minValue)
        return[`Data deve ser maior ou igual a Data de Abertura`];
      if(!v.maxValue)
        return[`Data deve conter o ano de ${this.anoletivo}`];
    },
    msgValidacaoAbe(v){
      if(!v.required)
        return ['Campo obrigatório'];
      if(!v.isValidDate)
        return[`Data inválida`];
      if(!v.minValue || !v.maxValue)
        return[`Data deve conter o ano de ${this.anoletivo}`];
    },
    stopArrowsAction(event) {
      if(event.keyCode === 38 || event.keyCode === 40) { event.preventDefault(); }
    },
    chosen(data){
      this.anoletivo = data.aaletivo.aaletivo;
      this.nivelescolar = data.cdinstruc.cdinstruc;
      this.tipoDeEnsino = data.cdinstruc.cntpensin;
      this.getMinimos()
      this.getFechamento();
      //console.log(this.nivelescolar)
      this.habilitarBotoes = false;
    },
    async getMinimos(){
      try{
        this.$Progress.start();
        const response = await CAARepository.getMinimo({aaletivo: this.anoletivo, cdinstruc: this.nivelescolar});
        if(response.data.results){
          //console.log(this.acaoMinimo)
          this.formMinimo = response.data.results;
          this.acaoMinimo = 'editar';
        }else{
          //console.log(this.acaoMinimo)
          this.formMinimo = setFormMinimo();
          this.formMinimo.aaletivo = this.anoletivo;
          this.formMinimo.cdinstruc = this.nivelescolar;
          this.acaoMinimo = 'novo';
        }
      }catch (error){
        console.log(error);
      }
      this.tabMinimo = true;
      this.$Progress.finish();
    },
    async getFechamento(){
      try{
        this.$Progress.start();
        const response = await CAARepository.getFechamento({aaletivo: this.anoletivo, cdinstruc: this.nivelescolar});
        this.formFechamento = response.data.results.map( fechamento => {
          return {
            ...fechamento,
            datainicio: moment(fechamento.datainicio, 'YYYY-MM-DD').format('DD/MM/YYYY'),
            datafim: moment(fechamento.datafim, 'YYYY-MM-DD').format('DD/MM/YYYY'),
          }
        });
      }catch (error){
        console.log(error);
      }
      this.tabFechamento = true;
      this.$Progress.finish();
    },
     async onSubmit(){
      this.$v.$touch();
      //console.log(this.$v)
      if (this.$v.$invalid) {
        return;
      }
      try{
        this.loading = true;
        this.$Progress.start();

        let fechamento = this.filtrarFechamento();
        const funcao = (this.acaoMinimo === 'novo') ? 'post' : 'put';

        const { data } = await CAARepository[`${funcao}Minimo`]({
          ...this.formMinimo,
          cntpensin: this.tipoDeEnsino,
        });

        const { data2 } = await CAARepository.postFechamento(fechamento);

        this.formMinimo = { ... data.results};
        this.submitText = data.message;
        this.snackbar = true;
        this.msgArrayError = [];
        this.acaoMinimo = 'editar';
        this.habilitarBotoes = false;
      }catch(e){
        this.msgArrayError = e.response.data.errorMessage;
        this.habilitarBotoes = true;
        this.loading = false;
        this.$Progress.finish();
      }
      this.getFechamento();
      this.$Progress.finish();
      this.loading = false;
    },
    cancelar(){
      this.loading2 = true;
      this.getMinimos()
      this.getFechamento();
      this.loading2 = false;
      this.habilitarBotoes = false;
    },
    filtrarFechamento(){
      let filtro = _.filter(this.formFechamento, function(o){
        return (o.datafim !== null && o.datainicio !== null);
      });

      return filtro;
    },
  },
  computed: {
    tabelaFechamento(){
      //console.log(this.formFechamento)
      return this.formFechamento;
    },
  },
}
</script>

<style scoped lang="scss">
  #btn-acoes-b {
    text-align: right;
  }

  .config-input-span {
    margin-left: 10px;
  }
  .teste {
    color: #FFF;
  }
</style>
